(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Apple-style: hovering the blurred backdrop closes the drawer, same as
  // the search drawer. Gated on drawer:afterShow/afterHide (DrawerElement's
  // own event names, dispatched once its open/close transition finishes -
  // not modal:afterShow/afterHide, which DrawerElement's constructor
  // overrides) rather than just "the overlay exists", so a cursor that's
  // already resting over the backdrop when the drawer starts opening - or
  // a fast reopen right after closing - can't trigger an instant,
  // mid-animation close before the drawer has actually finished sliding
  // into place.
  //
  // Debounced rather than closing on the very first mouseenter, for the
  // same reason as the search drawer: .drawer__inner's own box-shadow
  // bleeds a faint sliver above the panel's top edge into the overlay's
  // hit-test area, so a fast pass-through shouldn't count as "hovering the
  // backdrop".
  (function () {
    function init() {
      var cartDrawer = document.getElementById('CartDrawer');
      var overlay = cartDrawer && cartDrawer.querySelector('.overlay');
      if (!cartDrawer || !overlay || overlay.dataset.hoverCloseBound) return;
      overlay.dataset.hoverCloseBound = 'true';

      var ready = false;
      var hoverCloseTimer = null;

      cartDrawer.addEventListener('drawer:afterShow', function () {
        ready = true;
      });

      cartDrawer.addEventListener('drawer:afterHide', function () {
        ready = false;
        if (hoverCloseTimer !== null) {
          clearTimeout(hoverCloseTimer);
          hoverCloseTimer = null;
        }
      });

      overlay.addEventListener('mouseenter', function () {
        if (!ready) return;
        hoverCloseTimer = setTimeout(function () {
          hoverCloseTimer = null;
          if (typeof cartDrawer.hide === 'function') {
            // Same ghost-click risk as tapping the backdrop directly
            // (onButtonClick in theme.js) - a touch device can synthesize
            // this same mouseenter close path, so it needs the same guard.
            if (typeof cartDrawer.guardAgainstGhostClick === 'function') cartDrawer.guardAgainstGhostClick();
            cartDrawer.hide();
          } else {
            overlay.click();
          }
        }, 100);
      });

      overlay.addEventListener('mouseleave', function () {
        if (hoverCloseTimer === null) return;
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  // Closing the panel by moving into the dimmed backdrop (not just clicking
  // it) matches Apple's search: reuses the overlay's existing click-to-close
  // handler (bound by ModalElement to every [aria-controls] control) instead
  // of reimplementing the open/close logic here.
  //
  // Debounced rather than closing on the very first mouseenter: .drawer__inner
  // has its own box-shadow (0 12px 28px), which — being a plain visual blur
  // radiating in every direction from the panel's edge, not something that
  // affects hit-testing — bleeds a faint sliver above the panel's actual top
  // edge, into the overlay's own hit-test area (the overlay starts at that
  // same edge and extends from there down). That sliver reads visually as a
  // thin divider line right under the header, but it's really overlay
  // territory, so simply moving the cursor from the header down into the
  // search field crosses it and closed the drawer instantly. A short delay,
  // cancelled on mouseleave, means a genuine pass-through (crossing that
  // sliver on the way to the field) no longer closes anything, while
  // actually moving into and staying on the dimmed backdrop still does.
  (function () {
    function init() {
      var overlay = document.querySelector('.search-drawer .overlay');
      if (!overlay || overlay.dataset.hoverCloseBound) return;
      overlay.dataset.hoverCloseBound = 'true';

      var hoverCloseTimer = null;

      overlay.addEventListener('mouseenter', function () {
        hoverCloseTimer = setTimeout(function () {
          hoverCloseTimer = null;
          overlay.click();
        }, 100);
      });

      overlay.addEventListener('mouseleave', function () {
        if (hoverCloseTimer === null) return;
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Smoothly grow/shrink the panel as results change (typing in more or
  // fewer matches), instead of the height snapping instantly.
  //
  // This went through several broken versions before landing here. The
  // one that actually turned out to matter, verified with a real browser
  // (not just code review) against a minimal reproduction of this exact
  // markup: every earlier attempt measured "fromHeight" reactively,
  // AFTER the DOM mutation that changed the results. By the time any of
  // those handlers ran (whether a ResizeObserver/MutationObserver
  // callback, or a requestAnimationFrame queued from one), the browser
  // had ALREADY reflowed .drawer__inner to its new height:auto value —
  // so "fromHeight" and "newHeight" always came back identical, and
  // nothing ever animated, silently.
  //
  // Fixed by never measuring "before" reactively. Instead, while the
  // panel is open, lastKnownHeight always holds an up-to-date snapshot of
  // "wherever the box was on the previous frame" (mid-animation or
  // settled), ready before any mutation happens. It used to be kept by
  // polling the height once per animation frame; now a ResizeObserver
  // records it on every frame whose size changes, plus a single rAF read
  // on the frame after the panel opens and after each applyResize() (the
  // only frames a ResizeObserver can miss, see measure() below), so an
  // idle open panel no longer reads layout or requests a frame at all.
  // When a MutationObserver detects the results content changing, it
  // calls applyResize() synchronously (MutationObserver callbacks run as
  // a microtask, before the next animation frame, so lastKnownHeight is
  // guaranteed to still hold the pre-mutation value at that point) and
  // animates from that cached height to the freshly measured
  // post-mutation one.
  (function () {
    function init() {
      var drawer = document.getElementById('SearchDrawer');
      var inner = drawer && drawer.querySelector('.drawer__inner');
      var form = drawer && drawer.querySelector('.search__form');
      if (!drawer || !inner || !form || inner.dataset.resizeAnimBound) return;
      if (window.theme && theme.config && theme.config.motionReduced) return;
      inner.dataset.resizeAnimBound = 'true';

      var ready = false;
      var lastKnownHeight = null;
      var currentAnimation = null;
      var measureFrame = null;

      // One read on the frame after open and after each applyResize(): a
      // ResizeObserver only reports sizes that differ from its last report,
      // so it would miss e.g. the first frame of a shrink animation (which
      // still sits at the pre-change height).
      function measure() {
        measureFrame = null;
        if (ready) lastKnownHeight = inner.getBoundingClientRect().height;
      }

      function measureNextFrame() {
        if (measureFrame === null) measureFrame = requestAnimationFrame(measure);
      }

      // Every other frame on which the panel's size changes (including every
      // frame of a WAAPI height animation) is reported here, after layout and
      // before paint. Read with getBoundingClientRect() so it is the exact
      // same measurement applyResize() uses for newHeight.
      var sizeObserver = new ResizeObserver(function () {
        if (ready) lastKnownHeight = inner.getBoundingClientRect().height;
      });

      function applyResize() {
        if (!ready) return;

        var fromHeight = lastKnownHeight;

        if (currentAnimation) {
          currentAnimation.cancel();
          currentAnimation = null;
        }

        var newHeight = inner.getBoundingClientRect().height;
        lastKnownHeight = newHeight;
        measureNextFrame();

        if (fromHeight === null || Math.abs(newHeight - fromHeight) < 1) return;

        if (newHeight > fromHeight) {
          // Growing: .drawer__inner is already at its natural (larger)
          // auto height for the new content at this point — nothing here
          // sets height explicitly, so the box itself never needs to
          // move or resize on this frame. Mask out the newly-added
          // bottom portion and animate the mask away instead: the same
          // compositor-only clip-path technique already used for the
          // panel's own open reveal (never reported as unstable),
          // instead of animating height directly, which forces a full
          // layout recalculation on every single frame — a well-known
          // category of cross-browser animation inconsistency that
          // clip-path (paint/composite-only, no layout impact) avoids
          // entirely.
          var clipFromPercent = (1 - fromHeight / newHeight) * 100;
          currentAnimation = inner.animate(
            [{ clipPath: 'inset(0 0 ' + clipFromPercent + '% 0)' }, { clipPath: 'inset(0 0 0% 0)' }],
            { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
        } else {
          // Shrinking is untouched: this direction was already confirmed
          // working correctly and must not change.
          currentAnimation = inner.animate(
            [{ height: fromHeight + 'px' }, { height: newHeight + 'px' }],
            { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );
        }
        currentAnimation.onfinish = currentAnimation.oncancel = function () {
          currentAnimation = null;
        };
      }

      // Watches `hidden`, not `active`: `active` is only set ~75ms after
      // the drawer opens (see ModalElement.showTransition in theme.js),
      // but `hidden` is removed synchronously at the very start of
      // opening. Gating on `active` left a real race — if the very first
      // search's results mutation landed inside that 75ms window (ready
      // still false), applyResize() correctly no-opped, but nothing ever
      // retroactively caught up, so that specific transition stayed an
      // unanimated instant snap forever. That matches exactly what was
      // reported: the shrink direction never races this window (it only
      // ever happens well after the drawer has settled), but the first
      // grow can. Verified with a real browser: a search triggered as
      // early as 0ms after the open click now still animates correctly.
      new MutationObserver(function () {
        var visible = !drawer.hasAttribute('hidden');
        if (visible && !ready) {
          ready = true;
          lastKnownHeight = inner.getBoundingClientRect().height;
          sizeObserver.observe(inner);
          measureNextFrame();
        } else if (!visible && ready) {
          ready = false;
          if (currentAnimation) {
            currentAnimation.cancel();
            currentAnimation = null;
          }
          sizeObserver.unobserve(inner);
          if (measureFrame !== null) {
            cancelAnimationFrame(measureFrame);
            measureFrame = null;
          }
          lastKnownHeight = null;
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });

      // Called synchronously, not deferred to a requestAnimationFrame:
      // deferring it would let the next frame's measure() or
      // ResizeObserver callback run first and overwrite lastKnownHeight
      // with the post-mutation value before applyResize ever reads it.
      new MutationObserver(applyResize).observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['results']
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Tracks whether results have been shown at least once this drawer-open
  // session, via a .has-searched class the CSS above uses to stop Quick
  // Links from replaying their entrance animation every time the search
  // is cleared back to empty. Cleared on close so a genuine reopen still
  // gets the real entrance.
  (function () {
    function init() {
      var drawer = document.getElementById('SearchDrawer');
      var form = drawer && drawer.querySelector('.search__form');
      if (!drawer || !form || form.dataset.settleBound) return;
      form.dataset.settleBound = 'true';

      new MutationObserver(function () {
        if (form.hasAttribute('results')) {
          drawer.classList.add('has-searched');
        }
      }).observe(form, { attributes: true, attributeFilter: ['results'] });

      new MutationObserver(function () {
        if (!drawer.hasAttribute('hidden')) return;
        drawer.classList.remove('has-searched');
        // .entrance-done (added by the animationend listener below, once
        // per <li>, to strip its lingering post-entrance transform) never
        // gets removed on its own — Quick Links/result rows aren't
        // recreated between opens, they just sit in the DOM with that
        // class stuck on them, so its !important animation: none was
        // silently blocking their entrance from ever playing again on a
        // second or later open. Clearing it here, once the drawer has
        // actually closed, lets every row's entrance rule re-match and
        // replay in full on the next open, the same as .search__field's
        // already does (its animation isn't gated by any sticky class).
        var lis = form.querySelectorAll('.search__box li.entrance-done');
        for (var i = 0; i < lis.length; i++) {
          lis[i].classList.remove('entrance-done');
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Strips the lingering transform that animation-fill-mode: both leaves
  // on each result/Quick-Link <li> once its entrance animation finishes
  // (see the .entrance-done rule above for why that lingering transform
  // matters). Delegated on the form itself, not per-<li>, since results
  // are re-created via innerHTML on every keystroke — a per-element
  // listener would need to be re-bound on every render, while a single
  // delegated one keeps working for every <li> that ever appears.
  (function () {
    function init() {
      var drawer = document.getElementById('SearchDrawer');
      var form = drawer && drawer.querySelector('.search__form');
      if (!drawer || !form || form.dataset.entranceCleanupBound) return;
      form.dataset.entranceCleanupBound = 'true';

      form.addEventListener('animationend', function (event) {
        if (event.animationName !== 'search-drawer-move-in') return;
        var li = event.target.closest ? event.target.closest('.search__box li') : null;
        if (li) li.classList.add('entrance-done');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Snapshots --header-height into --search-header-height on the drawer
  // itself the instant it opens, so the CSS above can anchor the panel's
  // position to a value that can't change again for the rest of that
  // open session, even if --header-height itself gets recalculated
  // (it's a shared variable the header keeps live via its own
  // ResizeObserver in theme.js for the page's whole lifetime).
  (function () {
    function init() {
      var drawer = document.getElementById('SearchDrawer');
      if (!drawer || drawer.dataset.headerSnapshotBound) return;
      drawer.dataset.headerSnapshotBound = 'true';

      var viewport = window.visualViewport;
      var listening = false;
      var frame = null;

      function updateViewport() {
        frame = null;
        if (drawer.hasAttribute('hidden')) return;
        if (!viewport || !window.matchMedia('(max-width: 1023px)').matches) {
          drawer.style.removeProperty('--search-viewport-top');
          drawer.style.removeProperty('--search-viewport-height');
          return;
        }
        var keyboardOpen = window.innerHeight - viewport.height > 120;
        var top = keyboardOpen ? Math.max(0, viewport.offsetTop) : 0;
        drawer.style.setProperty('--search-viewport-top', top + 'px');
        drawer.style.setProperty('--search-viewport-height', viewport.height + 'px');
      }

      function scheduleViewport() {
        if (frame === null) frame = requestAnimationFrame(updateViewport);
      }

      new MutationObserver(function () {
        if (drawer.hasAttribute('hidden')) {
          if (listening) {
            viewport.removeEventListener('resize', scheduleViewport);
            viewport.removeEventListener('scroll', scheduleViewport);
            window.removeEventListener('resize', scheduleViewport);
            listening = false;
          }
          if (frame !== null) cancelAnimationFrame(frame);
          frame = null;
          drawer.style.removeProperty('--search-viewport-top');
          drawer.style.removeProperty('--search-viewport-height');
          return;
        }
        var headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        if (headerHeight) {
          drawer.style.setProperty('--search-header-height', headerHeight.trim());
        }
        if (viewport && !listening) {
          viewport.addEventListener('resize', scheduleViewport, { passive: true });
          viewport.addEventListener('scroll', scheduleViewport, { passive: true });
          window.addEventListener('resize', scheduleViewport, { passive: true });
          listening = true;
        }
        updateViewport();
      }).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultimate-pack-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ultimate-pack-faq')) {
    customElements.define('ultimate-pack-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || typeof Element.prototype.animate !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.items = new Map();
        this.querySelectorAll('details').forEach(details => {
          const summary = details.querySelector('summary');
          const panel = details.querySelector('[data-faq-panel]');
          if (!summary || !panel) return;
          this.items.set(details, { summary, panel, expanded: details.open, animation: null });
          details.dataset.expanded = String(details.open);
          summary.setAttribute('aria-expanded', String(details.open));
        });
        this.addEventListener('click', event => {
          if (event.defaultPrevented || event.button > 0) return;
          const details = event.target.closest('summary')?.parentElement;
          const item = this.items.get(details);
          if (!item) return;
          event.preventDefault();
          this.setExpanded(details, !item.expanded);
        }, options);
        this.addEventListener('toggle', event => {
          const item = this.items.get(event.target);
          if (!item || item.animation) return;
          item.expanded = event.target.open;
          event.target.dataset.expanded = String(item.expanded);
          item.summary.setAttribute('aria-expanded', String(item.expanded));
        }, { ...options, capture: true });
        // Only a width change reflows the answers (and so the height a running
        // animation is heading to). Height-only resizes - the mobile URL bar
        // showing or hiding while scrolling - used to snap a panel that was
        // still opening or closing.
        let width = window.innerWidth;
        window.addEventListener('resize', () => {
          if (window.innerWidth === width) return;
          width = window.innerWidth;
          this.settleAll();
        }, options);
        this.motionPreference.addEventListener('change', () => this.settleAll(), options);
        this.addEventListener('shopify:block:select', event => {
          const details = event.target.closest('details');
          if (this.items.has(details)) this.setExpanded(details, true);
        }, options);
      }

      setExpanded(details, expanded) {
        const item = this.items.get(details);
        if (!item || (expanded === item.expanded && !item.animation)) return;
        const start = details.open ? item.panel.getBoundingClientRect().height : 0;
        const answer = item.panel.firstElementChild;
        const fromOpacity = answer && details.open ? parseFloat(getComputedStyle(answer).opacity) : 0;
        item.animation?.cancel();
        item.animation = null;
        item.contentAnimation?.cancel();
        item.contentAnimation = null;
        item.expanded = expanded;
        details.dataset.expanded = String(expanded);
        item.summary.setAttribute('aria-expanded', String(expanded));
        if (!expanded && item.panel.contains(document.activeElement)) item.summary.focus({ preventScroll: true });
        item.panel.inert = !expanded;
        details.open = true;
        const end = expanded ? item.panel.scrollHeight : 0;
        if (this.motionPreference.matches || Math.abs(start - end) < 1) {
          this.settle(details, item);
          return;
        }
        const animation = item.panel.animate([
          { height: `${start}px` },
          { height: `${end}px` }
        // Closing uses an even ease-in-out: the opening curve front-loads
        // almost all the motion, which made the collapse snap shut.
        ], expanded
          ? { duration: 460, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          : { duration: 420, easing: 'cubic-bezier(.45, 0, .25, 1)' });
        item.animation = animation;
        // The answer text itself eases in - a soft fade with a slight
        // downward settle, starting just after the panel begins to open -
        // rather than just being uncovered by the growing height. Closing,
        // it fades out quickly ahead of the collapse. Starts from its
        // current opacity if the visitor clicks again mid-animation.
        if (answer) {
          item.contentAnimation = expanded
            ? answer.animate([
              { opacity: fromOpacity, transform: `translateY(${-6 * (1 - fromOpacity)}px)` },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 400, delay: fromOpacity > 0 ? 0 : 60, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' })
            : answer.animate([
              { opacity: fromOpacity || 1, transform: 'translateY(0)' },
              { opacity: 0, transform: 'translateY(-4px)' }
            ], { duration: 240, easing: 'cubic-bezier(.25, .1, .25, 1)', fill: 'forwards' });
        }
        animation.onfinish = () => {
          if (item.animation !== animation) return;
          this.settle(details, item);
        };
      }

      settle(details, item) {
        item.animation?.cancel();
        item.animation = null;
        item.contentAnimation?.cancel();
        item.contentAnimation = null;
        details.open = item.expanded;
        item.panel.inert = false;
      }

      settleAll() {
        this.items.forEach((item, details) => this.settle(details, item));
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.controller.abort();
        this.settleAll();
        this.items.forEach((item, details) => {
          delete details.dataset.expanded;
          item.summary.removeAttribute('aria-expanded');
        });
        this.items.clear();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
